import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {teamApi} from '../api';

export const teamKeys = {
  all: ['team'] as const,
  members: () => [...teamKeys.all, 'members'] as const,
  roles: () => [...teamKeys.all, 'roles'] as const
};

export function useTeamMembersQuery() {
  const client = useApiClient();

  return useQuery({
    queryKey: teamKeys.members(),
    queryFn: () => teamApi.fetchMembers(client),
    // Always refetch on mount — invites/removals from other sessions must show up immediately.
    refetchOnMount: 'always',
    select: response => response.data
  });
}
